import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Hook to set the document title with i18n support
 * @param titleKey - Translation key for the page title
 */
export function useDocumentTitle(titleKey?: string) {
  const { t } = useTranslation();

  useEffect(() => {
    const appName = t('app.name');
    
    if (titleKey) {
      const pageTitle = t(titleKey);
      document.title = `${appName} | ${pageTitle}`;
    } else {
      document.title = appName;
    }
  }, [titleKey, t]);
}
